import { useContext } from "react";

import styled from "styled-components";
import Context from "../../../Context";

const InfoBox = styled.section`
  cursor: pointer;
  transition: 0.15s ease-in-out;
  border: 1px solid var(--border);
  background: var(--mainBackground);
  /* color: var(--element); */
  padding: 15px 20px;
  /* max-width: 80vw; */
  margin: auto;
  width: 100%;
  display: flex;
  border-radius: 12px;
  flex-direction: row;
  justify-content: flex-start;
  /* justify-content: center; */
  align-items: center;
  gap: 15px;
  /* box-shadow: 0px 1px 10px 0 #0000000c; */

  &:hover {
    transform: scale(0.9);
  }
`;

const Name = styled.div`
  color: var(--element);
  font-size: 12px;
  font-weight: 700;
`;

const IconImage = styled.img`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  height: 35px;
  width: 35px;
  object-fit: contain;
`;

export default function NgoTypeButton({ item, onClick }) {
  const { colorMode } = useContext(Context);

  return (
    <InfoBox onClick={onClick}>
      <IconImage
        src={item.image}
        style={{ filter: `invert(${colorMode == "DARK" ? "1" : "0"})` }}
      ></IconImage>

      <Name>{item.label}</Name>
    </InfoBox>
  );
}
